import { render, staticRenderFns } from "./examinationfilesetting.vue?vue&type=template&id=1ba276d4&scoped=true"
import script from "./examinationfilesetting.vue?vue&type=script&lang=js"
export * from "./examinationfilesetting.vue?vue&type=script&lang=js"
import style0 from "./examinationfilesetting.vue?vue&type=style&index=0&id=1ba276d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba276d4",
  null
  
)

export default component.exports